import { render, staticRenderFns } from "./navigation.html?vue&type=template&id=3862ba4a&scoped=true&external"
import script from "./navigation.js?vue&type=script&lang=js&external"
export * from "./navigation.js?vue&type=script&lang=js&external"
import style0 from "./navigation.scss?vue&type=style&index=0&id=3862ba4a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3862ba4a",
  null
  
)

export default component.exports